import { Col, Row, Typography } from 'antd';
import React from 'react';
import {
  BillingDownloadsDropdown,
  InvoiceActionsButton,
  InvoiceState,
} from '@pay-bill/components';
import {
  InvoiceReviewFragmentType,
  ReverseInvoiceReviewFragmentType,
} from '@pay-bill/graphql';

const { Title } = Typography;

type Props =
  | {
      isSupplier: true;
      invoiceData?: undefined;
      reverseInvoiceData: ReverseInvoiceReviewFragmentType;
    }
  | {
      isSupplier: false;
      invoiceData: InvoiceReviewFragmentType;
      reverseInvoiceData?: undefined;
    };

export const BillingHeader = ({
  isSupplier,
  invoiceData,
  reverseInvoiceData,
}: Props) => {
  const code = isSupplier ? reverseInvoiceData.code : invoiceData.code;
  const state = isSupplier
    ? reverseInvoiceData.worksInvoice.state
    : invoiceData.state;
  const id = isSupplier ? reverseInvoiceData.id : invoiceData.id;

  return (
    <Row style={{ marginBottom: 16 }}>
      <Col span={16}>
        <Row align="middle" gutter={8}>
          <Col>
            <Title level={3} style={{ margin: 0 }}>
              {isSupplier ? 'Reverse Invoice' : 'Invoice'}: {code}
            </Title>
          </Col>
          <Col>
            <InvoiceState state={state} />
          </Col>
        </Row>
      </Col>
      <Col span={8}>
        <Row justify="end" align="middle">
          <BillingDownloadsDropdown id={id} isSupplier={isSupplier} />
          {!isSupplier && (
            <InvoiceActionsButton invoice={invoiceData} styleType="primary" />
          )}
        </Row>
      </Col>
    </Row>
  );
};
